/** Host do deploy de teste. Localhost e produção não mostram o selo da porta. */
export const DIARIO_TESTE_HOST = 'diarioteste.ergonsistemas.com.br';

export function resolveApiPortBadge(
  hostname: string,
  apiUpstreamPort: number | undefined,
): number | undefined {
  if (!apiUpstreamPort || hostname !== DIARIO_TESTE_HOST) {
    return undefined;
  }
  return apiUpstreamPort;
}
